import { WordsPipe } from './../pipes/words.pipe';
import { SplitcharactersPipe } from './../pipes/splitcharacters.pipe';
import { CharactersPipe } from './../pipes/characters.pipe';
import { NgModule, ModuleWithProviders } from '@angular/core';
export class TruncatePipesModule {
/**
 * Use in AppModule
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
        return {
            ngModule: TruncatePipesModule,
            providers: []
        };
    }
/**
 * Use in features modules with lazy loading
 * @return {?}
 */
public static forChild(): ModuleWithProviders {
        return {
            ngModule: TruncatePipesModule,
            providers: []
        };
    }

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        CharactersPipe,
        SplitcharactersPipe,
        WordsPipe
        // Pipes.
        // Directives.
    ],
    exports: [
        CharactersPipe,
        SplitcharactersPipe,
        WordsPipe
        // Pipes.
        // Directives.
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TruncatePipesModule_tsickle_Closure_declarations() {
/** @type {?} */
TruncatePipesModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TruncatePipesModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
